module.exports = __webpack_public_path__ + "static/construction_documents-a19fdeea813324e9b338bc8600550dab.jpg";